import DiscordLogo from '../../src/legacy/DiscordLogo';
export default DiscordLogo;
